module.exports = __webpack_public_path__ + "img/FullKikkomanLogo.079d7580.png";